@for (option of props.options; track option.label; let last = $last) {
  <ds-radio
    [label]="option.label"
    [description]="optionDescription(option)"
    [selected]="option.value === formControl.value"
    [state]="radioState"
    [name]="id"
    [value]="'' + option.value"
    [class.mr-4]="!last"
    [attr.data-id]="field.key"
    (selectedChange)="onSelect(option.value)"
  />
}
